import * as React from 'react';
import Paper from '@mui/material/Paper';
import { useDispatch, useSelector } from 'react-redux';

import DonationsTable from './DonationsTable';
import DonationFilters from './DonationFilters';
import { EmptyDataDiv } from '../../../components';
import { profileActions } from '../../../store/actions';
import { StyledPagination } from '../Styles/DonationTable';
import { useNonInitialEffect } from '../../../hooks/UseNonInitialEffect';
import DonationHistorySkeleton from '../../../components/skeletons/DonationHistorySkeleton';

export default function DonationHistory() {
    const dispatch = useDispatch();
    const donationHistory = useSelector(state => state.donations_paginate_by_user.donations_paginate_by_user);
    const [donationsList, setDonationList] = React.useState([]);
    const [loadingRecords, setLoadingRecords] = React.useState(false);
    const [state, setState] = React.useState({
        limit: 5,
        offset: 0,
        sortBy: 1,
        searchString: null,
    });
    const [page, setPage] = React.useState(0);


    React.useEffect(() => {
        if (!donationHistory)
            getHistoryData();
        else setDonationList(donationHistory.result)
    }, []);


    useNonInitialEffect(() => {
        setDonationList(donationHistory.result)
    }, [donationHistory]);

    useNonInitialEffect(() => {
        getHistoryData();
    }, [state])

    const updateState = (name, value) => {
        setState({
            ...state,
            [name]: value
        })
    }

    const handleChangePage = (event, newPage) => {
        updateState('offset', state.limit * newPage)
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        updateState('limit', event.target.value);
    };

    const getHistoryData = async () => {
        setDonationList([]);
        setLoadingRecords(true);
        const payload = {
            limit: state.limit,
            offset: state.offset,
            search_string: state.searchString,
            sort_by: state.sortBy
        }
        await dispatch(profileActions.getUserDonationHistory(payload))
        setLoadingRecords(false);
    }

    return (
        <Paper sx={MainComponentStyle}>
            <DonationFilters state={state} setState={setState} />

            {
                donationsList.length ?
                    <DonationsTable donationsList={donationsList} /> :
                    loadingRecords ? <DonationHistorySkeleton /> : <EmptyDataDiv message="No record exist" />
            }

            <StyledPagination
                rowsPerPageOptions={[5, 10, 25]}
                count={donationHistory?.total | 0}
                rowsPerPage={state.limit}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />

        </Paper>
    );
}

const MainComponentStyle = { p: 2, display: 'flex', flexFlow: 'column', gap: '10px' }